import config from 'constants/config'

/** Tier order from lowest to highest (higher index = higher tier) */
export function getTierOrder(): Array<App.LoyaltyTier> {
  return config.loyalty.tiersOrder
}

/** Get the rank of a tier (higher = better). Returns -1 for undefined. */
export function getTierRank(tier: App.LoyaltyTier | undefined): number {
  if (!tier) return -1
  return getTierOrder().indexOf(tier)
}
